import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

import { MediaWrapper } from '@/components/Cms/MediaWrapper';
import type { ContentfulImageWithFocalPointFragment } from '@/graphql/contentful/api';
import { theme } from '@/theme';

import type { CardProps } from '../../types';

import * as S from './ImageAndDidYouKnow.styles';

export const ImageAndDidYouKnow = ({
  aspectRatio,
  cardText,
  className,
  contentAlignment = 'right',
  media,
  mediaWrapperType,
  placeholderHeading,
  preload,
  textAlignment,
  textColor,
  visibleInDesktop,
  visibleInMobile,
}: CardProps) => {
  return (
    <S.Wrapper
      $visibleInDesktop={visibleInDesktop}
      $visibleInMobile={visibleInMobile}
      className={className}
      contentAlignment={contentAlignment!}
    >
      <S.InnerWrapper>
        {media && (
          <MediaWrapper
            {...(media as ContentfulImageWithFocalPointFragment)}
            aspectRatio={aspectRatio}
            data-test-id='MediaAndDidYouKnow-Media'
            mediaWrapperType={mediaWrapperType}
            preload={preload}
            sizes='(max-width: 600px) 50vw, 20vw'
          />
        )}
      </S.InnerWrapper>
      <S.TextWrapper contentAlignment={contentAlignment!}>
        {placeholderHeading && (
          <S.Title
            as={
              (placeholderHeading.headingSeoTag ??
                'h3') as keyof HTMLElementTagNameMap
            }
            data-testid='text'
          >
            {placeholderHeading.text}
          </S.Title>
        )}
        {cardText && (
          <S.Text
            color={textColor ?? theme.colors.default}
            dangerouslySetInnerHTML={{
              __html: documentToHtmlString(cardText.json),
            }}
            data-testid='text'
            textAlignment={textAlignment ?? 'left'}
          />
        )}
      </S.TextWrapper>
    </S.Wrapper>
  );
};
